import { Confirmation } from 'primeng/api';
import { ButtonProps } from 'primeng/types/button';

/** The way out of a confirmation: the neutral secondary button, as Cancel is everywhere else. */
const REJECT_BUTTON: ButtonProps = { severity: 'secondary' };

/** Options for `ConfirmationService.confirm()`: Cancel in the secondary style, confirm in the primary one. */
export function confirmation(options: Confirmation): Confirmation {
    return { rejectButtonProps: REJECT_BUTTON, ...options };
}

/** Same, for an action that destroys data (delete, overwrite): the confirm button is red. */
export function destructiveConfirmation(options: Confirmation): Confirmation {
    const danger: ButtonProps = { severity: 'danger' };
    return { rejectButtonProps: REJECT_BUTTON, acceptButtonProps: danger, ...options };
}
